/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DraftArticle } from '../../models/draft-article';
import { UpdateDraftArticleRequest } from '../../models/update-draft-article-request';

export interface UpdateDraftArticle$Params {
  id: string;
      body: UpdateDraftArticleRequest
}

export function updateDraftArticle(http: HttpClient, rootUrl: string, params: UpdateDraftArticle$Params, context?: HttpContext): Observable<StrictHttpResponse<DraftArticle>> {
  const rb = new RequestBuilder(rootUrl, updateDraftArticle.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {"style":"simple"});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DraftArticle>;
    })
  );
}

updateDraftArticle.PATH = '/v0/draft-articles/{id}';
